import { createAction, props } from '@ngrx/store';
import { Company, PowerUser } from '@ridango/core';

export const fetchAllCompanies = createAction('[Company]: Fetch all companies');
export const fetchAllCompaniesSuccess = createAction(
    '[Company]: Fetch all companies success',
    props<{ companies: Company[] }>()
);
export const fetchAllCompaniesFailed = createAction('[Company]: Fetch all companies fail');
export const setAllCompanies = createAction('[Company]: Set all companies', props<{ companies: Company[] }>());
export const setSelectedCompany = createAction('[Company]: Set selected company', props<{ company: Company }>());

export const saveCompanyProfile = createAction('[Company]: Save company profile', props<{ company: Company }>());
export const saveCompanyProfileSuccess = createAction(
    '[Company]: Save company profile success',
    props<{ company: Company }>()
);
export const saveCompanyProfileFailed = createAction('[Company]: Save company profile fail');

export const fetchPowerUsers = createAction('[Company]: Fetch power users', props<{ companyId: number }>());
export const fetchPowerUsersSuccess = createAction(
    '[Company]: Fetch power users success',
    props<{ powerUsers: PowerUser[] }>()
);
export const fetchPowerUsersFailed = createAction('[Company]: Fetch power users fail');

export const deletePowerUser = createAction(
    '[Company]: Delete power user',
    props<{ companyId: number; userId: number }>()
);
export const deletePowerUserFailed = createAction('[Company]: Delete power user fail');

export const addPowerUser = createAction(
    '[Company] Add power user',
    props<{ powerUser: PowerUser; companyId: number }>()
);
export const addPowerUserFailed = createAction('[Company]: Add power user fail');
